import { render, staticRenderFns } from "./AddressManage.vue?vue&type=template&id=654dbbb1&"
import script from "./AddressManage.vue?vue&type=script&lang=js&"
export * from "./AddressManage.vue?vue&type=script&lang=js&"
import style0 from "./AddressManage.vue?vue&type=style&index=0&id=654dbbb1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports